import DailyOutputReportPage from "./DailyOutputReportPage";

export default function DailyMigrationPersonnelOutputPage() {
  return (
    <DailyOutputReportPage
      title="Daily Migration Personnel Output"
      label="Personnel"
      endpoint="/reports/daily-migration-personnel-output"
      detailEndpoint="/reports/daily-migration-personnel-output/details"
      detailParamName="person"
      exportEndpoint="/reports/daily-migration-personnel-output/export"
      filterEndpoint="/reports/migration-personnel-list"
      filterLabel="Personnel"
      filterParamName="personnel"
      exportFilenamePrefix="Daily_Migration_Personnel_Output"
      nameExtractor={(name) => {
        const match = name.match(/^(.+)\s+\(.*\)$/);
        return match ? match[1] : name;
      }}
    />
  );
}
